import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { MODAL_TYPE_LOGIN } from '../../../../../../../services/modal/constants';

import { showModal } from '../../../../../../../services/modal/actions';

import useCartController from '../../../../../../../services/ebon/hooks/useCartController';

import EbonSelectorLeftContainer from './EbonSelectorLeftContainer';
import EbonSelectorRightContainer from './EbonSelectorRightContainer';
import { LoadingComponent } from '../../../../../../loading/LoadingComponent';

import './PaymentRequestEbonSelectorComponentStyle.scss';

const PaymentRequestEbonSelectorComponent = ({
    partner,
    validatedCashbackAmount,
    i18n,
    isAuthenticated,
    fetching,
    ebonPaymentConfig,
    showModal
}) => {
    const {
        cart,
        handleItemChange,
        getCartTotal,
        addItemCart,
        getCartQuantity
    } = useCartController();

    const cartTotalQuantity = getCartQuantity(cart);
    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;
    const defaultBasketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimitDefault;
    const effectiveBasketLimit = basketLimit || defaultBasketLimit || undefined;

    const isBasketLimitReached = () => {
        return effectiveBasketLimit && cartTotalQuantity >= effectiveBasketLimit;
    };
    const getBasketLimitMessage = () => {
        if (basketLimit && cartTotalQuantity >= basketLimit) {
            return i18n.CAPPING_MESSAGE;
        }
        if (defaultBasketLimit && cartTotalQuantity >= defaultBasketLimit) {
            return i18n.DEFAULT_CAPPING_MESSAGE;
        }
        return undefined;
    };

    const showLoginModal = event => {
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    return (
        <div id="payment-request-ebon-selector-container" className="container">
            {fetching && (
                <div className="loading-div">
                    <LoadingComponent />
                </div>
            )}

            {!fetching && (
                <React.Fragment>
                    <EbonSelectorLeftContainer
                        partner={partner}
                        cart={cart}
                        addItemCart={addItemCart}
                        cartTotalQuantity={cartTotalQuantity}
                        basketLimit={effectiveBasketLimit}
                        isBasketLimitReached={isBasketLimitReached}
                        getBasketLimitMessage={getBasketLimitMessage}
                        loginRequired={!isAuthenticated}
                        showLoginModal={showLoginModal}
                    />
                    <EbonSelectorRightContainer
                        partner={partner}
                        cart={cart}
                        handleItemChange={handleItemChange}
                        getCartTotal={getCartTotal}
                        isBasketLimitReached={isBasketLimitReached}
                        loginRequired={!isAuthenticated}
                        showLoginModal={showLoginModal}
                        validatedCashbackAmount={validatedCashbackAmount}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

PaymentRequestEbonSelectorComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    validatedCashbackAmount: PropTypes.number.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR,
        isAuthenticated: state.authentication.isAuthenticated,
        fetching: state.ebon.ebonsFetching,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PaymentRequestEbonSelectorComponent)
);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/ebon/ebonselector/PaymentRequestEbonSelectorComponent.js